import { Money } from '../../core/model/money';
import { RentalObjectCategory } from '../../rent/model/const/enums';

export abstract class PropertyBase {
  constructor(data?: any) {
    if (data) {
      this.averageContractAge = data.averageLeaseAgreementAge;
      this.category = data.category;
      this.nextMonthRent = data.nextMonthRentAmount;
      this.totalRentalObjectCount = data.numberOfRentalObjects;
      this.vacantRentalObjectCount = data.numberOfVacantObjects;
    }
  }

  averageContractAge: any;
  category: RentalObjectCategory;
  nextMonthRent: Money;
  totalRentalObjectCount: number;
  vacantRentalObjectCount: number;

  getRentedCount() {
    var rented = this.totalRentalObjectCount - this.vacantRentalObjectCount;
    return rented ? rented : null;
  }
}
